module.exports = __webpack_public_path__ + "static/applyCustomer-81b123c44311ac3a599dfde4c19b982b.jpg";